/** @format — Shipment panel chat helpers */

const SESSION_CACHE_KEY = "dockie_shipment_chat_sessions";
const HISTORY_CACHE_KEY = "dockie_shipment_chat_history";

export function resolveShipmentId(shipment) {
  return shipment?.id ?? shipment?._raw?.id ?? null;
}

/** Scope flags for ADK session prep — activates shipment-scoped agent tools */
export function buildShipmentScopedForwardedProps(shipment) {
  const shipmentId = resolveShipmentId(shipment);
  const bookingCode = resolveShipmentBookingCode(shipment);
  const props = {
    shipment_chat_scope: true,
    shipment_id: shipmentId,
    current_shipment_id: shipmentId,
    booking_id: bookingCode,
    tracking_code: bookingCode,
  };
  return props;
}

export function resolveShipmentBookingCode(shipment) {
  const raw = shipment?._raw ?? shipment ?? {};
  const candidates = [
    shipment?.bookingId,
    raw.booking_id,
    raw.bookingId,
    raw.booking_number,
    raw.bookingNumber,
    raw.shipper_order_id,
    raw.shipperOrderId,
    raw.external_id,
    raw.externalId,
    raw.tracking_number,
    raw.trackingNumber,
    raw.reference,
  ];
  for (const c of candidates) {
    if (c != null && String(c).trim()) {
      return String(c).replace(/^#/, "").trim();
    }
  }
  return null;
}

export function readShipmentChatCache(shipmentId) {
  if (!shipmentId) return [];
  try {
    const all = JSON.parse(sessionStorage.getItem(SESSION_CACHE_KEY) || "{}");
    const rows = all[shipmentId];
    return Array.isArray(rows) ? rows : [];
  } catch {
    return [];
  }
}

export function writeShipmentChatCache(shipmentId, sessionTurns) {
  if (!shipmentId) return;
  try {
    const all = JSON.parse(sessionStorage.getItem(SESSION_CACHE_KEY) || "{}");
    if (sessionTurns?.length) {
      all[shipmentId] = sessionTurns;
    } else {
      delete all[shipmentId];
    }
    sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(all));
  } catch {
    /* ignore quota */
  }
}

export function readShipmentHistoryCache(shipmentId) {
  if (!shipmentId) return [];
  try {
    const all = JSON.parse(sessionStorage.getItem(HISTORY_CACHE_KEY) || "{}");
    const rows = all[shipmentId];
    return Array.isArray(rows) ? rows : [];
  } catch {
    return [];
  }
}

export function writeShipmentHistoryCache(shipmentId, messages) {
  if (!shipmentId) return;
  try {
    const all = JSON.parse(sessionStorage.getItem(HISTORY_CACHE_KEY) || "{}");
    if (messages?.length) {
      all[shipmentId] = messages;
    } else {
      delete all[shipmentId];
    }
    sessionStorage.setItem(HISTORY_CACHE_KEY, JSON.stringify(all));
  } catch {
    /* ignore quota */
  }
}
